var _path, _path2, _path3, _path4, _path5, _path6, _path7, _circle, _path8, _path9, _path10, _path11, _circle2, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _circle3, _circle4, _circle5, _path23, _path24, _path25, _path26, _path27, _circle6, _path28, _path29, _path30, _path31, _path32, _rect, _path33;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWebDesign(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    "data-name": "Layer 1",
    width: 831.06442,
    height: 647.00005,
    viewBox: "0 0 831.06442 647.00005",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M216.41356,126.5a31.98219,31.98219,0,0,0-31.94577,31.94581v583.109A31.9821,31.9821,0,0,0,216.41356,773.5H535.81078a31.982,31.982,0,0,0,31.9458-31.94525v-583.109A31.98221,31.98221,0,0,0,535.81078,126.5Z",
    transform: "translate(-184.46779 -126.49998)",
    fill: "#f1c232"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M226.85448,144.65014a24.26412,24.26412,0,0,0-24.23654,24.23654V731.11282a24.26423,24.26423,0,0,0,24.23654,24.237H525.36986a24.2642,24.2642,0,0,0,24.23651-24.237V168.88668a24.26414,24.26414,0,0,0-24.23651-24.23654Z",
    transform: "translate(-184.46779 -126.49998)",
    fill: "#fff"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M520.24608,263.147H231.97826a5.34457,5.34457,0,0,1-5.33829-5.33829V186.3018a5.34456,5.34456,0,0,1,5.33829-5.33829H520.24608a5.34458,5.34458,0,0,1,5.33832,5.33829v71.50694A5.34458,5.34458,0,0,1,520.24608,263.147ZM231.97826,183.09879a3.20647,3.20647,0,0,0-3.203,3.203v71.50694a3.20646,3.20646,0,0,0,3.203,3.203H520.24608a3.20644,3.20644,0,0,0,3.203-3.203V186.3018a3.20645,3.20645,0,0,0-3.203-3.203Z",
    transform: "translate(-184.46779 -126.49998)",
    fill: "#f1c232"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M520.24608,546.07607H231.97826a5.3446,5.3446,0,0,1-5.33829-5.33825V408.37438a5.34457,5.34457,0,0,1,5.33829-5.33829H520.24608a5.3446,5.3446,0,0,1,5.33826,5.33829V540.73782A5.34459,5.34459,0,0,1,520.24608,546.07607ZM231.97826,405.17141a3.20646,3.20646,0,0,0-3.203,3.203V540.73782a3.20645,3.20645,0,0,0,3.203,3.203H520.24608a3.20643,3.20643,0,0,0,3.203-3.203V408.37438a3.20644,3.20644,0,0,0-3.203-3.203Z",
    transform: "translate(-184.46779 -126.49998)",
    fill: "#f1c232"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M518.11077,374.18331H389.99144a5.34456,5.34456,0,0,1-5.33828-5.33829V297.3381a5.34456,5.34456,0,0,1,5.33828-5.33829H518.11077a5.3446,5.3446,0,0,1,5.33825,5.33829v71.507A5.34458,5.34458,0,0,1,518.11077,374.18331ZM389.99144,294.13512a3.20648,3.20648,0,0,0-3.203,3.203v71.50692a3.20648,3.20648,0,0,0,3.203,3.203H518.11077a3.20646,3.20646,0,0,0,3.203-3.203v-71.507a3.20646,3.20646,0,0,0-3.203-3.203Z",
    transform: "translate(-184.46779 -126.49998)",
    fill: "#f1c232"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M360.09758,719.03646H231.97826a5.34458,5.34458,0,0,1-5.33829-5.33832v-133.431a5.3446,5.3446,0,0,1,5.33829-5.33825H360.09758a5.3446,5.3446,0,0,1,5.33829,5.33825v133.431A5.3446,5.3446,0,0,1,360.09758,719.03646ZM231.97826,577.06417a3.20645,3.20645,0,0,0-3.203,3.203v133.431a3.20646,3.20646,0,0,0,3.203,3.203H360.09758a3.20647,3.20647,0,0,0,3.203-3.203v-133.431a3.20646,3.20646,0,0,0-3.203-3.203Z",
    transform: "translate(-184.46779 -126.49998)",
    fill: "#f1c232"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M518.11077,719.03646H389.99144a5.34456,5.34456,0,0,1-5.33828-5.33832v-133.431a5.34459,5.34459,0,0,1,5.33828-5.33825H518.11077a5.34459,5.34459,0,0,1,5.33825,5.33825v133.431A5.34459,5.34459,0,0,1,518.11077,719.03646ZM389.99144,577.06417a3.20645,3.20645,0,0,0-3.203,3.203v133.431a3.20646,3.20646,0,0,0,3.203,3.203H518.11077a3.20644,3.20644,0,0,0,3.203-3.203v-133.431a3.20644,3.20644,0,0,0-3.203-3.203Z",
    transform: "translate(-184.46779 -126.49998)",
    fill: "#f1c232"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 90.16611,
    cy: 323.42542,
    r: 21.74535,
    fill: "#f1c232"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M324.85527,435.42849a3.62422,3.62422,0,0,0,0,7.24844H495.7116a3.62423,3.62423,0,0,0,0-7.24844Z",
    transform: "translate(-184.46779 -126.49998)",
    fill: "#f1c232"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M324.85527,457.17379a3.62423,3.62423,0,0,0-.01529,7.24844h73.53528a3.62422,3.62422,0,1,0,0-7.24844Z",
    transform: "translate(-184.46779 -126.49998)",
    fill: "#f1c232"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M257.95464,491.93835c-2.75687,0-5.00031,1.626-5.00031,3.62423s2.24344,3.62421,5.00031,3.62421H493.68376c2.7569,0,5.00031-1.626,5.00031-3.62421s-2.24347-3.62423-5.00031-3.62423Z",
    transform: "translate(-184.46779 -126.49998)",
    fill: "#f1c232"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M257.95464,513.68368c-2.75687,0-5.00031,1.626-5.00031,3.6242s2.24344,3.62421,5.00031,3.62421H493.68376c2.7569,0,5.00031-1.626,5.00031-3.62421s-2.24347-3.6242-5.00031-3.6242Z",
    transform: "translate(-184.46779 -126.49998)",
    fill: "#f1c232"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 92.30142,
    cy: 92.81155,
    r: 21.74535,
    fill: "#f1c232"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M326.99059,204.81463a3.62423,3.62423,0,0,0,0,7.24844H497.84691a3.62423,3.62423,0,1,0,.01532-7.24844c-.00513,0-.01019,0-.01532,0Z",
    transform: "translate(-184.46779 -126.49998)",
    fill: "#f1c232"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M326.99059,226.56a3.62423,3.62423,0,0,0,0,7.24845h73.52a3.62423,3.62423,0,0,0,.01529-7.24845q-.00765,0-.01529,0Z",
    transform: "translate(-184.46779 -126.49998)",
    fill: "#f1c232"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M359.98418,374.19634h-120.187l28.284-48.9902a5.7757,5.7757,0,0,1,10.00406,0l12.08255,20.92773,20.54456-35.584a7.23126,7.23126,0,0,1,12.52515,0ZM243.49538,372.061H356.286l-34.898-60.44354a5.09525,5.09525,0,0,0-8.8259,0l-22.39423,38.787L276.23571,326.2738a3.63969,3.63969,0,0,0-6.30481,0Z",
    transform: "translate(-184.46779 -126.49998)",
    fill: "#f1c232"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M513.72679,374.19634h-120.187l28.284-48.9902a5.77567,5.77567,0,0,1,10.00409,0l12.08258,20.92773,20.54455-35.584a7.23125,7.23125,0,0,1,12.52515,0ZM397.23806,372.061H510.02855l-34.898-60.44354a5.09526,5.09526,0,0,0-8.82587,0l-22.39422,38.787L429.97826,326.2738a3.63969,3.63969,0,0,0-6.30481,0Z",
    transform: "translate(-184.46779 -126.49998)",
    fill: "#f1c232"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M360.09758,374.18331H231.97826A5.34457,5.34457,0,0,1,226.64,368.845V297.3381a5.34457,5.34457,0,0,1,5.33829-5.33829H360.09758a5.34457,5.34457,0,0,1,5.33829,5.33829v71.507A5.34456,5.34456,0,0,1,360.09758,374.18331ZM231.97826,294.13512a3.20648,3.20648,0,0,0-3.203,3.203v71.50692a3.20648,3.20648,0,0,0,3.203,3.203H360.09758a3.20649,3.20649,0,0,0,3.203-3.203v-71.507a3.20649,3.20649,0,0,0-3.203-3.203Z",
    transform: "translate(-184.46779 -126.49998)",
    fill: "#f1c232"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M259.27791,602.44479a3.62424,3.62424,0,1,0,0,7.24847h73.52a3.62424,3.62424,0,1,0,0-7.24847Z",
    transform: "translate(-184.46779 -126.49998)",
    fill: "#f1c232"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M259.27791,623.79787a3.62424,3.62424,0,1,0,0,7.24848h73.52a3.62424,3.62424,0,1,0,0-7.24848Z",
    transform: "translate(-184.46779 -126.49998)",
    fill: "#f1c232"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M296.03816,691.52053a22.81284,22.81284,0,1,1,22.81284-22.8128h0A22.83866,22.83866,0,0,1,296.03816,691.52053Zm0-43.49036a20.67753,20.67753,0,1,0,20.67753,20.67749h0a20.70157,20.70157,0,0,0-20.67753-20.67742Z",
    transform: "translate(-184.46779 -126.49998)",
    fill: "#f1c232"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M490.81108,691.52053a3.62424,3.62424,0,1,0,0-7.24847h-73.52a3.62424,3.62424,0,0,0,0,7.24847Z",
    transform: "translate(-184.46779 -126.49998)",
    fill: "#f1c232"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M490.81108,670.16744a3.62424,3.62424,0,1,0,0-7.24847h-73.52a3.62423,3.62423,0,0,0,0,7.24847Z",
    transform: "translate(-184.46779 -126.49998)",
    fill: "#f1c232"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M454.05083,602.44479A22.81284,22.81284,0,1,1,431.238,625.25765v-.00006A22.8387,22.8387,0,0,1,454.05083,602.44479Zm0,43.49035a20.67752,20.67752,0,1,0-20.67743-20.67761v.00006a20.70159,20.70159,0,0,0,20.67743,20.67749Z",
    transform: "translate(-184.46779 -126.49998)",
    fill: "#f1c232"
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 234.63652,
    cy: 132.19294,
    r: 54,
    fill: "#6c63ff",
    opacity: 0.3,
    style: {
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 234.63652,
    cy: 132.19294,
    r: 36,
    fill: "#6c63ff",
    opacity: 0.3,
    style: {
      isolation: "isolate"
    }
  }), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 234.63652,
    cy: 132.19294,
    r: 25,
    fill: "#6c63ff"
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 111.63652,
    cy: 497.19294,
    r: 39.92126,
    fill: "#6c63ff",
    opacity: 0.3,
    style: {
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 111.63652,
    cy: 497.19294,
    r: 26.61417,
    fill: "#6c63ff",
    opacity: 0.3,
    style: {
      isolation: "isolate"
    }
  }), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 111.63652,
    cy: 497.19294,
    r: 18.48206,
    fill: "#6c63ff"
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 277.63652,
    cy: 341.19294,
    r: 45.92126,
    fill: "#6c63ff",
    opacity: 0.3,
    style: {
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 277.63652,
    cy: 341.19294,
    r: 30.61417,
    fill: "#6c63ff",
    opacity: 0.3,
    style: {
      isolation: "isolate"
    }
  }), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 277.63652,
    cy: 341.19294,
    r: 21.25984,
    fill: "#6c63ff"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M675.56516,538.99387l-9.4466,15.95785a11.91479,11.91479,0,0,1-18.8245,2.20648l0,0a11.91479,11.91479,0,0,1,1.5904-17.93133l15.36522-11.10951c14.75351-19.97192,23.23117-53.91527,30.45537-90.64927l30.02146,3.52095C716.98846,471.03439,698.48462,504.34462,675.56516,538.99387Z",
    transform: "translate(-184.46779 -126.49998)",
    fill: "#ffb8b8"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M679.28433,448.18181l48.81831,13.844V376.77592l-6.4805,2.09663a37.50077,37.50077,0,0,0-24.16529,24.22612Z",
    transform: "translate(-184.46779 -126.49998)",
    fill: "#f1c232"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M779.10684,753.47841l-18.21579-.72863c-5.982-61.56568-13.62-117.47614-29.14526-146.45494-15.03514,16.10457-18.4506,66.98345-20.96683,136.25409H693.12832c-18.55582-79.82993-23.24105-136.43,0-190.17282h94.7221Z",
    transform: "translate(-184.46779 -126.49998)",
    fill: "#2f2e41"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M711.87876,754.8946l-31.61725,16.15229a6.96061,6.96061,0,0,1-9.55005-3.4232h0a6.96063,6.96063,0,0,1,2.79094-8.73732l4.31132-2.59785,12.0044-17.94694,20.46061-1.61531,3.74284,3.5869A9.04269,9.04269,0,0,1,711.87876,754.8946Z",
    transform: "translate(-184.46779 -126.49998)",
    fill: "#2f2e41"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M776.12873,770.0308l-35.49018.99732a6.96062,6.96062,0,0,1-7.1521-7.19508v0a6.96062,6.96062,0,0,1,6.2749-6.69l5.00932-.49295,18.552-11.04634,19.16907,7.33432,1.83815,4.84726A9.0427,9.0427,0,0,1,776.12873,770.0308Z",
    transform: "translate(-184.46779 -126.49998)",
    fill: "#2f2e41"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 555.57694,
    cy: 210.69175,
    r: 23.82091,
    fill: "#ffb8b8"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M779.10684,375.31866,729.5599,394.26308c2.88588-15.55575,2.922-30.21038-1.82158-43.35358l31.69547-5.46473C756.774,359.10907,765.013,368.391,779.10684,375.31866Z",
    transform: "translate(-184.46779 -126.49998)",
    fill: "#ffb8b8"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M799.50852,566.22011c-43.60884,8.27958-78.7244,2.96789-107.10883-13.11536C705.5279,507.8711,707.39546,457.82412,703.959,405.51a25.28066,25.28066,0,0,1,15.35326-24.907l12.43357-5.28427c6.70409,15.23465,22.15522,6.45534,38.61747-5.10042l20.34253,8.98856a17.32689,17.32689,0,0,1,10.29955,16.85913C796.93854,465.55869,791.47228,540.062,799.50852,566.22011Z",
    transform: "translate(-184.46779 -126.49998)",
    fill: "#f1c232"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M814.08115,556.01927l-1.2967,18.586a12.85187,12.85187,0,0,1-13.63938,11.93131h0a12.85188,12.85188,0,0,1-10.07971-19.63726l10.44319-16.7091c6.17016-24.05147,1.27555-58.69342-5.829-95.45073l29.14526-8.01494C826.94045,477.47616,822.30538,515.29785,814.08115,556.01927Z",
    transform: "translate(-184.46779 -126.49998)",
    fill: "#ffb8b8"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M767.31338,321.71563s4.45313-9.79688-7.125-14.25c0,0-9.79688-16.03126-29.39064-5.34375,0,0-13.35938,5.34375-13.35938,19.59376s-4.45313,16.92188-4.45313,16.92188,6.63148-6.80329,8.41273-12.147,15.63416-6.55609,20.97791-1.21234,18.70314,4.45313,18.70314,4.45313l-.89063,19.59375s4.45313-11.57813,6.23438-11.57813S769.98526,321.71563,767.31338,321.71563Z",
    transform: "translate(-184.46779 -126.49998)",
    fill: "#2f2e41"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M833.02557,447.45318l-48.81831,13.844V376.04729l6.48049,2.09663A37.50075,37.50075,0,0,1,814.853,402.37Z",
    transform: "translate(-184.46779 -126.49998)",
    fill: "#f1c232"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 224.96862,
    y: 644.45791,
    width: 606.0958,
    height: 2,
    fill: "#f1c232"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M867.10814,609.56178c13.25,18.73,16.75,125.33,17.53,159.5.02.77.04,1.5.05,2.19h33.54c.41-.73.79-1.45,1.15-2.19,19.88-39.24,8.85-86.29,8.27-88.67,1.50994,7.48-5.32,29.16-13.04,50.16C909.89818,665.98176,869.62816,612.82178,867.10814,609.56178Z",
    transform: "translate(-184.46779 -126.49998)",
    fill: "#f1c232"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWebDesign);
export default __webpack_public_path__ + "static/media/web-design.bf23b7c9041cd11ec0fc92576848ce7c.svg";
export { ForwardRef as ReactComponent };